import { render, staticRenderFns } from "./ExchangeSubmit.vue?vue&type=template&id=7ea7998d&"
import script from "./ExchangeSubmit.vue?vue&type=script&lang=ts&"
export * from "./ExchangeSubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports